/* Native modal preserves focus and Escape behavior without navigating away. */
(function () {
  if (customElements.get('ecosystem-showcase')) return;
  customElements.define('ecosystem-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const panel = this.querySelector('[data-ecosystem-product-panel]');
      const content = this.querySelector('[data-ecosystem-product-content]');
      const productButtons = [...this.querySelectorAll('[data-ecosystem-product]')];
      let productTrigger;
      const closeDetails = (restoreFocus) => {
        panel.hidden = true;
        productButtons.forEach(button => button.setAttribute('aria-expanded', 'false'));
        if (restoreFocus && productTrigger) productTrigger.focus({ preventScroll: true });
      };
      productButtons.forEach(button => {
        button.addEventListener('click', () => {
          const wasOpen = button.getAttribute('aria-expanded') === 'true';
          closeDetails(false);
          if (wasOpen) return;
          productTrigger = button;
          const template = this.querySelector('[data-ecosystem-template="' + button.dataset.ecosystemProduct + '"]');
          content.replaceChildren(template.content.cloneNode(true));
          const model = content.querySelector('[data-ecosystem-model]');
          if (model) model.textContent = this.dataset.model || '';
          button.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
          panel.focus({ preventScroll: true });
          panel.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        });
      });
      this.querySelector('[data-ecosystem-detail-close]').addEventListener('click', () => closeDetails(true));
      panel.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); closeDetails(true); }
      });
      this.addEventListener('ecosystem:collapse', () => closeDetails(false));

      /* Image gallery. Each tile ships its own list of photos as JSON, so the
         dialog steps through every image of that product rather than one cover.
         The list is already locale-correct: Liquid picked the German or English
         file set before rendering. */
      const dialog = this.querySelector('dialog');
      const image = this.querySelector('[data-ecosystem-full-image]');
      const liveVisual = this.querySelector('[data-ecosystem-live-visual]');
      const counter = this.querySelector('[data-ecosystem-counter]');
      const prevButton = this.querySelector('[data-ecosystem-prev]');
      const nextButton = this.querySelector('[data-ecosystem-next]');
      let slides = [];
      let index = 0;
      let trigger;

      const readGallery = (key) => {
        const node = this.querySelector('[data-ecosystem-gallery="' + key + '"]');
        if (!node) return [];
        try {
          const parsed = JSON.parse(node.textContent);
          return Array.isArray(parsed) ? parsed.filter(slide => slide && slide.src) : [];
        } catch (error) {
          return [];
        }
      };

      const render = () => {
        const slide = slides[index];
        if (!slide) return;
        if (liveVisual) { liveVisual.hidden = true; liveVisual.replaceChildren(); }
        image.hidden = false;
        image.src = slide.src;
        image.alt = slide.alt || '';
        const many = slides.length > 1;
        prevButton.hidden = !many;
        nextButton.hidden = !many;
        counter.hidden = !many;
        if (many) {
          const template = (window.ECOSYSTEM_I18N && window.ECOSYSTEM_I18N.counter) || '';
          counter.textContent = template
            .replace('{index}', String(index + 1))
            .replace('{total}', String(slides.length));
        }
      };

      const step = (delta) => {
        if (slides.length < 2) return;
        index = (index + delta + slides.length) % slides.length;
        render();
      };

      this.querySelectorAll('[data-ecosystem-zoom]').forEach(button => {
        button.addEventListener('click', () => {
          // Personalized artwork uses the very same dialog and close/focus
          // behavior as the product photos, while staying live and local.
          const visual = this.querySelector('[data-ecosystem-visual="' + button.dataset.ecosystemZoom + '"]');
          if (visual && liveVisual) {
            trigger = button;
            slides = [];
            index = 0;
            image.hidden = true;
            prevButton.hidden = nextButton.hidden = counter.hidden = true;
            liveVisual.replaceChildren(visual.content.cloneNode(true));
            liveVisual.hidden = false;
            dialog.showModal();
            return;
          }
          const found = readGallery(button.dataset.ecosystemZoom);
          if (!found.length) return;
          trigger = button;
          slides = found;
          index = 0;
          render();
          dialog.showModal();
        });
      });

      prevButton.addEventListener('click', () => step(-1));
      nextButton.addEventListener('click', () => step(1));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); step(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); step(1); }
      });

      /* Horizontal swipe on touch, ignored when the gesture is mostly vertical
         so scrolling a tall image still works. */
      let touchX = null;
      let touchY = null;
      dialog.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) { touchX = null; return; }
        touchX = event.touches[0].clientX;
        touchY = event.touches[0].clientY;
      }, { passive: true });
      dialog.addEventListener('touchend', event => {
        if (touchX === null || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touchX;
        const dy = event.changedTouches[0].clientY - touchY;
        touchX = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        step(dx < 0 ? 1 : -1);
      }, { passive: true });

      this.querySelector('[data-ecosystem-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        if (liveVisual) { liveVisual.hidden = true; liveVisual.replaceChildren(); }
        if (trigger) trigger.focus({ preventScroll: true });
      });
    }
  });
})();
